import Signin from "../component/Signin";

export default function Login() {
  return (
    <div className="Login">
      <h1> <span>🖐️😉️</span><br/>welcome to klam</h1>
      <Signin />
    </div>
  );
}
